<template>
  <AppModalEdit
    v-model="isActive"
    @clickExec="saveEditedItem"
    title="代理店マージン新規申請"
    exec-button-text="追加申請"
  >
    <v-container v-if="item != null" grid-list-md>
      <v-layout wrap>
        <v-flex xs2>
          <h4>代理店名</h4>
        </v-flex>
        <v-flex xs10>
          <SearchAndSelect
            :loading="loading"
            :searched-list="searchedList"
            :selected-item-name="selectedItemName"
            @search="searchAgency"
            @change="selectItem"
            button-text="代理店を選択して下さい"
          />
        </v-flex>
        <v-flex xs2>
          <h4>名称</h4>
        </v-flex>
        <v-flex xs10>
          <v-text-field
            v-model="item.name"
            browser-autocomplete="disabled"
            style="width:80%"
          />
        </v-flex>
        <v-flex xs2>
          <h4>マージン率</h4>
        </v-flex>
        <v-flex xs10>
          <v-text-field
            v-model="item.marginValue"
            @keydown.arrow-down.prevent
            @keydown.arrow-up.prevent
            @wheel.prevent
            type="number"
            style="width:80px;"
            append-outer-icon="%"
          />
        </v-flex>
      </v-layout>
      <DateRangePicker
        :default-use-date-range="item.useDateRange"
        :start="item.startDate"
        :end="item.endDate"
        @change="changeDateRange"
        label="使用可能期間"
        uselabel="期間を指定する"
        not-uselabel="期間を指定しない"
      />
      <v-layout wrap>
        <v-flex xs2>
          <h4>メモ</h4>
        </v-flex>
        <v-flex xs10>
          <v-textarea v-model="item.memo" style="width:80%" />
        </v-flex>
      </v-layout>
    </v-container>
  </AppModalEdit>
</template>

<script>
import DateRangePicker from '@/components/Shared/CrudUI/DateRangePicker'
import SearchAndSelect from '@/components/Shared/CrudUI/SearchAndSelect'
import { AddAgencyMarginForm } from '@/models/AgencyMargin.js'

export default {
  components: { DateRangePicker, SearchAndSelect },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: undefined,
      loading: false,
      selectedItemName: '',
    }
  },
  computed: {
    isActive: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    searchedList() {
      return this.$store.getters['agency/agencySearchResult']
    },
  },
  watch: {
    value(val) {
      if (val) this.init()
    },
  },
  methods: {
    init() {
      this.item = new AddAgencyMarginForm()
    },
    async saveEditedItem() {
      console.log('save')
      console.log(this.item)
      await this.item.createRequest()
    },
    changeDateRange(obj) {
      const start = obj.useDateRange ? obj.startDate : ''
      const end = obj.useDateRange ? obj.endDate : ''
      this.item.startDate = start
      this.item.endDate = end
    },
    async searchAgency(keyword) {
      this.loading = true
      this.$store.dispatch('agency/SEARCH_AGENCY')
      try {
        await this.$store.dispatch('agency/SEARCH_AGENCY', { keyword })
      } catch (e) {
        this.loading = false
        const error = new Error('代理店の取得に失敗しました。')
        throw error
      }
      this.loading = false
    },
    selectItem(item) {
      this.selectedItemName = item.name
      this.item.agencyId = item.id
    },
  },
}
</script>
